import { Grid, Paper, Table, Loader, DateRangePicker, Input } from "../../../components";
import moment from "moment";
import { Link } from "@mui/material";
import { formatMoney, formatNumberCompact } from "../../../utils";
import { useAxios } from "../../../hooks";
import { Fragment, useEffect } from "react";
import { GridFilterInputValueProps } from "@mui/x-data-grid-pro";
import { useFormik } from "formik";
import currency from "currency.js";

const today = moment().toDate()
const oneMonth = moment().add(5, 'days').toDate()

const diff = moment(oneMonth).diff(today, 'days')

const month: Array<Date> = []

for (let day = 0; day < diff; day++) {
    month.push(moment(today).add(day, 'day').toDate())
}

const currentYear = moment().year()

const statusOptions = [
    { value: 'AWAITING_ORDER_CONFIRMATION', label: 'Aguardando Confirmação' },
    { value: 'CANCELLED', label: 'Cancelado' },
    { value: 'PENDING', label: 'Pendente' },
    { value: 'PAID', label: 'Pago' },
    { value: 'LATE', label: 'Atrasado' },
]

function DateRangeSelector(props: GridFilterInputValueProps) {
    const { item, applyValue } = props;
  
    return (
        <DateRangePicker 
            endDate={item.value?.endDate}
            startDate={item.value?.startDate}
            onChange={(value) => {
                applyValue({
                    ...item,
                    value
                })
            }}
        />
    );
  }

export function Bonus () {
    const [bonus, fetchBonus] = useAxios({
        url: `/bonus/monthly`
    }, {
        manual: true
    })

    const formik = useFormik({
        initialValues: {
            month: moment().month(),
            year: moment().year()
        },
        onSubmit: () => {}
    })

    const {values} = formik
    
    useEffect(() => {
        fetchBonus({
            params: {
                month: values.month,
                year: values.year
            }
        })
    }, [values])

    console.log(bonus)

    return (
        <Grid container justifyContent="center" /*minHeight={"calc(100vh - 64px)"}*/ padding={3} gap={3} >
            {bonus.loading ? (
                <div style={{
                    display: 'flex',
                    flex: '1',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                    <Loader />
                </div>
            ) :(
            <Fragment> 
                <Grid item xs={12} sm={10}>
                    <Grid container gap={1}>
                        <Grid item xs={2}>
                            <Input 
                                label="Mês"
                                select
                                options={Array.from({length: 12}).map((_, index) => {
                                    return {
                                        label: moment().month(index).format('MMMM'),
                                        value: index
                                    }
                                })}
                                name="month"
                                value={formik.values.month}
                                onChange={formik.handleChange}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <Input 
                                label="Ano"
                                select
                                options={Array.from({ length: 3 }).map((_, index) => {
                                    return {
                                        label: String(currentYear - index),
                                        value: currentYear - index
                                    }
                                })}
                                name="year"
                                value={formik.values.year}
                                onChange={formik.handleChange}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} sm={10}>
                    <Paper elevation={1}>
                    <Table 
                        columns={[
                            { field: 'name', headerName: 'Usuário', flex: 1, renderCell: ({value, row}) => {
                                return (
                                    <Link href={`/admin/usuarios/${row.id}`}>
                                        {value}
                                    </Link>
                                )
                            }},
                            { field: 'orders', type: 'number', headerName: 'Emissões', flex: 1 },
                            { field: 'miles', type: 'number', headerName: 'Milhas Negociadas', flex: 1, valueFormatter: ({value}) => formatNumberCompact(value) },
                            { field: 'profit', type: 'number', headerName: 'Lucro Gerado', flex: 1, valueGetter: ({row}) => currency(row.sell_price).subtract(row.total_cost).value, valueFormatter: ({value}) => formatMoney(value) },
                            { field: 'amount', type: 'number', headerName: 'Comissão', flex: 1, valueFormatter: ({value}) => formatMoney(value) },
                        ]}
                        rows={(bonus?.data || [])}
                    />
                    </Paper>
                </Grid>
            </Fragment>
            )}
        </Grid>
    )
}